// Content for the Expérience numérique final call to action.
export type Bi = { fr: string; en: string }

export const dxFinalCta = {
  eyebrow: { fr: 'Expérience numérique', en: 'Digital experience' },
  navy: { fr: 'Et si tous vos services', en: 'What if all your services' },
  indigo: [
    { fr: 'commençaient', en: 'started' },
    { fr: 'au même endroit ?', en: 'in the same place?' },
  ] as Bi[],
  body: {
    fr: 'Découvrez comment BCITI | ATNA peut réunir votre site Web, votre portail et votre application mobile dans une seule expérience connectée — prête à évoluer avec vos besoins.',
    en: 'Discover how BCITI | ATNA can bring your website, your portal and your mobile app together in one connected experience — ready to evolve with your needs.',
  },
  primary: { fr: 'Demander une démo', en: 'Request a demo' },
  secondary: { fr: 'Parler à notre équipe', en: 'Talk to our team' },
  signatureNavy: { fr: 'Commencez par l’expérience.', en: 'Start with the experience.' },
  signatureIndigo: { fr: 'Faites évoluer toute la relation.', en: 'Grow the whole relationship.' },
}

export type FinalEntryKey = 'web' | 'portal' | 'app'

export const dxFinalEntries: { key: FinalEntryKey; label: Bi[] }[] = [
  { key: 'web', label: [{ fr: 'Site Web', en: 'Intelligent' }, { fr: 'intelligent', en: 'website' }] },
  { key: 'portal', label: [{ fr: 'Portail', en: 'My Space' }, { fr: 'Mon espace', en: 'portal' }] },
  { key: 'app', label: [{ fr: 'App mobile', en: 'Mobile app' }] },
]
